import React from 'react';
import { AudioDto } from '@/service/type';
import { AudioDetailDto } from '@/service/interface';
import { ChevLeftFilledIcon, CloseFilledIcon } from '@/components/Icons';
import { DownloadButtonEllipse } from '../DownloadButtonEllipse';

interface SongDetailHeaderProps {
  isLinkToHistory: boolean;
  closeHistory: () => void;
  selectedName?: string;
  onClose?: () => void;
  setSelectedInfo: (audioList: AudioDto | null | AudioDetailDto) => void;
  audioInfo: AudioDto | AudioDetailDto;
}

export const SongDetailHeader: React.FC<SongDetailHeaderProps> = ({
  isLinkToHistory,
  closeHistory,
  selectedName,
  onClose,
  setSelectedInfo,
  audioInfo,
}) => {
  return (
    <div className="flex justify-between items-center mt-[16px] pl-[16px] pr-[8px]">
      <div className="">
        {isLinkToHistory ? (
          <div
            onClick={closeHistory}
            className="cursor-pointer flex items-center text-jen-size-heading-07 text-jen-content-tertiary "
          >
            <ChevLeftFilledIcon
              className=" relative top-[-1px]"
              fillColor="#48484b"
            />
            <div className="max-w-[200px] truncate">BACK TO {selectedName}</div>
          </div>
        ) : (
          <div
            onClick={() => {
              onClose?.();
              setSelectedInfo(null);
            }}
            className="cursor-pointer p-jen-spacing-4 rounded-[4px] bg-jen-border"
          >
            <CloseFilledIcon className="w-[16px] h-[16px]" />
          </div>
        )}
      </div>
      <DownloadButtonEllipse audioInfo={audioInfo} />
    </div>
  );
};
